var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverview = function SvgOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.067 5.55c-2.875.318-5.15 2.79-5.15 5.75 0 3.172 2.604 5.783 5.775 5.783 2.952 0 5.425-2.275 5.74-5.158h-5.74a.625.625 0 0 1-.625-.625zm-6.4 5.75c0-3.861 3.17-7.033 7.025-7.033.345 0 .625.28.625.625v5.783h5.775c.345 0 .625.28.625.625 0 3.861-3.171 7.033-7.025 7.033-3.863 0-7.025-3.172-7.025-7.033",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.683 2.292c0-.346.28-.625.625-.625a7.02 7.02 0 0 1 4.967 2.058 7.04 7.04 0 0 1 2.058 4.967c0 .345-.28.625-.625.625h-6.297a.625.625 0 0 1-.727-.617zm1.25 5.775V2.95a5.77 5.77 0 0 1 3.458 1.659 5.8 5.8 0 0 1 1.658 3.458z",
    clipRule: "evenodd"
  })));
};
export default SvgOverview;